(function(){
    'use strict';
  
    angular
    .module('app')
    .controller('HomeController', HomeController)
  
    function HomeController(API,$sce, $timeout, $state, $scope, $location, $rootScope){
      let vm = this;
      vm.trocaSolucao = trocaSolucao;
      vm.tab = 0;
      vm.solutionLastIndex = 4;
      vm.$onInit = () => {
          getFromAPI();
      }
      function getFromAPI() {
          API.get('publicidade/').then(result => {
              vm.banner = result.data;
              angular.forEach(vm.banner, function(elemento, key){
                if (elemento.titulo_publicidade) {
                    elemento.titulo_publicidade = elemento.titulo_publicidade.split("#");
                  }
              });
          });

          API.get('/parceiros').then(result => {
            vm.clientes = result.data;
            $timeout(function() {
                vm.flex_clientes();
            },1000)
            vm.existe_slider = vm.clientes.filter(cliente => cliente.lead_parceiro == vm.date);
        });
        
          API.get('projeto/destaques').then(result => {
              vm.solucoes = result.data;
              if (vm.solucoes.length < 5) {
                  vm.solutionLastIndex = vm.solucoes.length - 1;
              }
          });
          API.get('paginas/1').then(result => {
              vm.conheca = result.data[0];
          });
          API.get('imovel/destaques').then(result => {
              vm.links = result.data;
          });
      }
      vm.flex_clientes = function(){
        $('.flex_clientes').flexslider({
            animation: "fade",
            slideshow: true,
            controlNav: true,
            directionNav: false
        });
    }
      function trocaSolucao(opcao){
          if (opcao == 1) {
              if (vm.tab < vm.solutionLastIndex) {
                  vm.tab++;
              } else {
                  vm.tab = 0;
              }
          }
          if (opcao == 2) {
              if (vm.tab > 0) {
                  vm.tab--;
              } else {
                  vm.tab = vm.solutionLastIndex;
              }
          }
      }
  
      vm.flex_home = function(){
          $('.flex_home').flexslider({
              animation: "fade",
              slideshow: true,
              controlNav: false,
              directionNav: false
          });
      }
  
  }//fim controller
  
  
  })();